module.exports = __webpack_public_path__ + "img/hohesLicht.1fa02533.jpg";